<template>
    <v-dialog v-model="active" persistent :width="$root.isTouch ? '100%' : '45%'" >
        <v-card elevation="11" flat :style="bgfondo">
            <v-container fluid >
                <v-row >
                    <v-col cols="12">
                        <v-card :class="$root.isTouch ? 'elevation-12 ml-2' : 'elevation-12'">
                            <div class="mt-1 text-center" style="background-color:#ff4132">
                                <img src="@/assets/img/logo-contigo-seguros-white.png" alt="" width="40%">
                            </div>
                            <v-card-text>
                                <v-form ref="form">
                                    <v-text-field v-model="obForm.userName" filled shaped color="primary" dense
                                        label="Login" name="login" prepend-icon="person" type="text"
                                        :rules="usuarioRule" />

                                    <v-text-field v-model="obForm.userPass" filled shaped color="primary" dense
                                        label="Password" name="password" prepend-icon="lock" type="password"
                                        :rules="claveRule" @keypress.enter.native="login" />
                                </v-form>
                            </v-card-text>
                            <v-card-actions style="background-color:#ff4132">
                                <v-btn block class="mt-1 mb-1" rounded outlined color="accent" @click="login"><span
                                        style="color:#fff">Iniciar Sesión</span></v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
                <v-snackbar v-model="obAlert.open" :timeout="obAlert.timeout" right dense>
                    {{ obAlert.text }}
                    <v-btn color="blue" text @click="obAlert.open = false"> Close </v-btn>
                </v-snackbar>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name:'LoginFakeComponent',
        props:{
            active:{
                type:Boolean,
                default:false
            }
        },
        inject:['closeModalLoginFake'],
        data : () => ({
            mostrar:false,
            bgfondo: "background-image: url('" + require('@/assets/img/bg-screen.png') + "'); background-size: cover",
            obForm: {
                userName: null,
                userPass: null
            },
            loading: false,
            obAlert: {
                open: false,
                timeout: 2000,
                text: ''
            },
            usuarioRule: [v => !!v || 'El campo usuario es requerido'],
            claveRule: [v => !!v || 'El campo usuario es requerido'],
        }),
        watch:{
            active(val){
                if(val){
                    localStorage.removeItem('token');
                    axios.defaults.headers.common['Authorization'] = null;
                }
            }
        },
        methods:{
            login() {
                try {
                    if (!this.$refs.form.validate()) throw 'Debe corregir la información.';
                    this.loading = true;

                    axios.post(`${BASE_URI}seguridad/login`, this.obForm)
                        .then((r) => {
                            if (_.size(_.get(r, ['data', 'data'], [])) == 0) throw 'Credenciales Invalidas.';
                            this.loading = false;
                            localStorage.setItem('token', _.replace(r.data.data.token.token, '"', ''));
                            axios.defaults.headers.common['Authorization'] = localStorage.getItem('token');
                            this.mostrar = false;
                            this.closeModalLoginFake();
                        })
                        .catch((e) => {
                            this.loading = false;
                            mensajesAlerta(e, 'E');
                        });

                } catch (error) {
                    mensajesAlerta(error, 'E');
                }
            }
        }
    }
</script>
<style>
    .wrapper {
  display: flex;
  /* width: 100vw; */
  height: 95vh;
  text-align: center;
}

.item {
  flex: 1;
  align-self: center;
  justify-content: center;
}
</style>